import { ChevronLeftIcon } from './CheckoutIcons';
import { TOUCH_TARGET_CLASS } from './styles';

interface StepBackButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
}

export function StepBackButton({ label, onClick, className = '' }: StepBackButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${TOUCH_TARGET_CLASS} w-full inline-flex items-center justify-center gap-1.5 rounded-lg px-4 text-sm font-semibold text-text-medium hover:text-chocolate-dark hover:bg-champagne/60 transition-colors ${className}`}
    >
      <ChevronLeftIcon className="w-4 h-4" />
      {label}
    </button>
  );
}
